"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CognitoIdentityClient["default"];
  }
});
var _CognitoIdentityClient = _interopRequireDefault(require("./CognitoIdentityClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }